import React, { memo, useContext } from 'react';
import Animated, { useAnimatedStyle, interpolate, Extrapolation, } from 'react-native-reanimated';
import { StyleSheet, View } from 'react-native';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import { CardView } from 'design-system/CardView';
import UpgradeButton from 'design-system/UpgradeButton';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { WalkthroughContext } from 'features/feed/components/walkthrough/context';
import { isWeb } from '../../../constants';
import AccountsChart from './AccountsChart';
import useOverviewChart from '../hooks/useOverviewChart';
const AccountsHeaderGraph = ({ onLayout, title, scrollX, blurValues, onPressUpgrade, isInTab, }) => {
    const { width } = useAppFrameDimensions(isInTab);
    const isInWalkthrough = useContext(WalkthroughContext);
    const { pieData, chartType, requesting, setChartType, selectedPeriod, selectedInfoObj, selectedInfoObj2, portfolioDataSet, portfolioDataSet2, setSelectedPeriod, } = useOverviewChart(title);
    const isWebUnlocked = isWeb &&
        (title === 'Net Worth - Main' ||
            title === 'Net Worth - Asset' ||
            title === 'Net Worth - Debt');
    const upgradeContainerStyle = useAnimatedStyle(() => blurValues && onPressUpgrade
        ? {
            opacity: isWebUnlocked
                ? 1
                : interpolate(scrollX.value, [width * 2.5, width * 3], [0, 1], Extrapolation.CLAMP),
        }
        : { opacity: 0 }, [blurValues, isWebUnlocked, onPressUpgrade, scrollX, width]);
    const graphContainerStyle = useAnimatedStyle(() => blurValues && onPressUpgrade
        ? {
            opacity: isWebUnlocked
                ? 0
                : interpolate(scrollX.value, [width * 2.25, width * 2.75], [1, 0], Extrapolation.CLAMP),
        }
        : {
            opacity: 1,
        }, [blurValues, isWebUnlocked, onPressUpgrade, scrollX, width]);
    return (<View onLayout={onLayout}>
      <CardView noMarginBottom noMarginTop={!isWeb} noMargin={isInWalkthrough} style={isInWalkthrough ? styles.walkthroughCardView : undefined}>
        <Animated.View style={graphContainerStyle} pointerEvents={blurValues &&
            (title === 'Net Worth - Main' ||
                title === 'Net Worth - Asset' ||
                title === 'Net Worth - Debt')
            ? 'none'
            : undefined}>
          <AccountsChart title={title} pieData={pieData} chartType={chartType} requesting={requesting} setChartType={setChartType} selectedPeriod={selectedPeriod} selectedInfoObj={selectedInfoObj} selectedInfoObj2={selectedInfoObj2} portfolioDataSet={portfolioDataSet} portfolioDataSet2={portfolioDataSet2} setSelectedPeriod={setSelectedPeriod}/>
        </Animated.View>
        {!isInWalkthrough &&
            blurValues &&
            onPressUpgrade &&
            (title === 'Net Worth - Main' ||
                title === 'Net Worth - Asset' ||
                title === 'Net Worth - Debt') &&
            (!isWeb || !requesting) ? (<Animated.View style={[upgradeContainerStyle, styles.upgradeContainer]}>
            <UpgradeButton chipText="Enhanced tracking" text="Net worth is available for Emma Pro and Ultimate customers. Get started today by learning more." onCard onPress={onPressUpgrade}/>
          </Animated.View>) : null}
      </CardView>
      {!isInWalkthrough && <Spacer h={16}/>}
    </View>);
};
const styles = StyleSheet.create({
    upgradeContainer: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        paddingHorizontal: rem(32),
    },
    walkthroughCardView: {
        borderRadius: 0,
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
});
export default memo(AccountsHeaderGraph);
